class PostAPI {

  static all(filter) {
    let url = this.postsUrl(filter)

    return fetch(url, {
      credentials: 'same-origin'
    })
    .then(this.handleStatus)
  }

  static handleStatus(response) {
    if (!response.ok) {
      // Fetch doesn't reject on HTTP error status
      throw Error(`Request rejected with status ${response.status}`)
    }
    return response
  }

  static postsUrl(filter) {
    if ( filter == 'location') {
      return `/wp-json/utron/v2/vacancies_by_location`
    } else if ( filter == 'time' ) {
      return `/wp-json/utron/v2/vacancies_by_time`
    } else {
      return `/wp-json/utron/v2/vacancies_by_company`
    }
  }

}

export default PostAPI



// WEBPACK FOOTER //
// ./src/js/vacancies/api/PostAPI.js